import { createZustandShallowStore } from '@/lib/zustand';
import { persist } from 'zustand/middleware';

interface LayoutStoreLoadingProps {
    type: 'preventAll' | 'default' | 'initial';
    show: boolean;
}

export type LoadingStoreProps = {
    loading: LayoutStoreLoadingProps;
    setLoading: (
        fn:
            | LayoutStoreLoadingProps
            | ((t: LayoutStoreLoadingProps) => LayoutStoreLoadingProps)
    ) => void;

    isAppLoading: boolean;
    setAppLoading: (fn: boolean | ((t: boolean) => boolean)) => void;
};

export const useLoadingStore = createZustandShallowStore<LoadingStoreProps>()(
    persist(
        (set, get) => {
            return {
                loading: {
                    show: false,
                    type: 'initial',
                },
                setLoading(fn) {
                    set((state) => ({
                        loading:
                            typeof fn === 'function' ? fn(state.loading) : fn,
                    }));
                },
                isAppLoading: false,
                setAppLoading(fn) {
                    set((state) => ({
                        isAppLoading:
                            typeof fn === 'function'
                                ? fn(state.isAppLoading)
                                : fn,
                    }));
                },
            };
        },
        { name: 'loading-store', skipHydration: true }
    )
);
